import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router, RouterLink } from '@angular/router';
import { ProtuneApiService } from '../../../services/protune-api.service';
import { of } from 'rxjs';
import { SubscriptionLevels } from '../../../models/subscription-levels';
import { ErrorHandlerService } from '../../../services/error-handler.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  errors: any;
  submitted: boolean = false;
  selectedSubscriptionLevel: string = '';
  products: any[];

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private protuneApiService: ProtuneApiService,
    private router: Router,
    private errorHandler: ErrorHandlerService) {

  }


  get emailInUse() {
      if (this.errors) {
        let duplicateUsername = Object.hasOwn(this.errors, 'DuplicateUserName') && this.errors.DuplicateUserName != null;
        return duplicateUsername;
      }

      return false;
  }

  confirmPasswordValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value.password === control.value.confirmPassword ? null : { PasswordNoMatch: true };
  };


  ngOnInit() {
    this.registerForm = this.fb.group({
      firstName: new FormControl<string>('', { validators: [Validators.required] }),
      lastName: new FormControl<string>('', { validators: [Validators.required] }),
      email: new FormControl<string>('', { validators: [Validators.required, Validators.email] }),
      password: new FormControl<string>('', { validators: [Validators.required] }),
      confirmPassword: new FormControl<string>(''),
      tosAgree: new FormControl<boolean>(false, { validators: [Validators.requiredTrue] }),
      subscriptionLevel: new FormControl<string>(SubscriptionLevels.Trial),
      includeAIEngineer: new FormControl<boolean>(false)
    }, { validators: this.confirmPasswordValidator });

    this.registerForm.valueChanges.subscribe(() => {
      this.submitted = false;
    });

    
    this.registerForm.controls.email.valueChanges.subscribe(() => {
      if (this.errors && this.errors.DuplicateUserName) {
        this.errors.DuplicateUserName = null;
      }
    });

    this.protuneApiService.getProducts()
      .subscribe(products => {
        this.products = products;
      });
    
  }

  get registerFormControl() {
    return this.registerForm.controls;
  }

  register(subscriptionLevel: string) {
    const val = this.registerForm.value;

    if (this.registerForm.valid) {
      this.submitted = true;
      this.selectedSubscriptionLevel = subscriptionLevel;
      this.authService.register(val.firstName, val.lastName, val.email, val.password, subscriptionLevel)
        .subscribe({
          next:
            () => {
              console.log('Account created successfully');
              console.log('User is logged in');

              var products: string[] = [subscriptionLevel];

              if (subscriptionLevel !== SubscriptionLevels.Trial) {
                if (val.includeAIEngineer) {
                  products.push(SubscriptionLevels.AIEngineer)
                }

                this.protuneApiService
                  .getPaymentLink(products)
                  .subscribe({
                    next: (res: any) => {
                      if (res) {
                        window.location.href = res.url;
                      }
                      else {
                        this.router.navigateByUrl('/');
                      }
                    },
                    error: err => {
                      this.submitted = false;
                      this.selectedSubscriptionLevel = '';
                      this.errorHandler.handleError('', err.error, err.req, true);
                    }
                  });
              }
              else {
                this.router.navigateByUrl('/');
              }
            },
          error: err => {
            this.submitted = false;
            this.selectedSubscriptionLevel = '';
            if (err.error?.errors?.DuplicateUserName) {
              this.errorHandler.handleError(`Username ${val.email} is already taken.`, null, null, true);
            }
            else {
              this.errorHandler.handleError('Unable to create the account.', err.error, err.req, true);
            }
          }
        });
    }
  }

  getProductPrice(key: string) {
    let products = this.products.filter(p => p.key == key);
    return products[0].price.toString() ?? '';
  }
}
